import React, { useState } from 'react';
import {connect} from 'react-redux'

import { Field, Form } from 'react-final-form';
import {
  Col,
} from 'reactstrap';
import renderDropZoneField from "@/shared/components/form/DropZone";

import axios from 'axios';

import { fetchEventSocialWallImages } from '@/services/events/index';

import {useDispatch, flashError, flashSuccess} from "@/shared/components/flash"

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

const SocialWallBgUpload = ({ setSocialWallImages, toggle, onCancel, program }) => {

  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  function handleUpload(values){

    let data = new FormData();
    
    if(!values.files){
        return
    }

    values.files.forEach(element => {
        data.append('image[]', element)
    });
    setLoading(true)
    axios
    .post(`/organization/${program.organization_id}/event_social_wall_images`, data,
      {
        headers: {
            "Content-type": "multipart/form-data",
        },
      }
    )
    .then((res) => {
      if (res.status == 200) { //fetch all on success!
        flashSuccess(dispatch, "Image uploaded!")
        fetchEventSocialWallImages(program, 'both')
        .then( response => {
          setSocialWallImages(response)
        })
      }
    })
    .catch((error) => {
      flashError(dispatch, error.response.data)
      setLoading(false);
    });
  }
  
  async function onSubmit (files){
    handleUpload(files);
    await sleep(800);
    toggle('2');
  }

  return (
    <Col md={12} lg={12} className="dropzone-iconupload manager-program-settings-picker__pane">
      <Form onSubmit={onSubmit}>
        {({ handleSubmit }) => (
          <form className="form manager-program-settings-picker__form" onSubmit={handleSubmit}>
            <p className="manager-program-settings-picker__copy">
              Use `jpg`, `jpeg`, `gif`, `png`, or `ico` files up to 5 MB.
            </p>

            <Field
              name="files"
              component={renderDropZoneField}
            />
            <div className="manager-program-settings-dialog__actions">
              <button
                type="submit"
                className="manager-program-settings-dialog__action is-primary"
                disabled={loading}
              >
                Upload
              </button>
              <button
                type="button"
                className="manager-program-settings-dialog__action"
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      </Form>
    </Col>
  );
};


export default connect((state) => ({
  program: state.program
}))(SocialWallBgUpload);
